import { ChatbotConfidence } from '../types';

const STYLES: Record<
  ChatbotConfidence,
  { bg: string; text: string; border: string; dot: string; label: string }
> = {
  high: {
    bg: 'bg-green-50',
    text: 'text-green-700',
    border: 'border-green-200',
    dot: 'bg-green-500',
    label: 'High confidence',
  },
  medium: {
    bg: 'bg-amber-50',
    text: 'text-amber-800',
    border: 'border-amber-200',
    dot: 'bg-amber-500',
    label: 'Medium confidence',
  },
  low: {
    bg: 'bg-red-50',
    text: 'text-red-700',
    border: 'border-red-200',
    dot: 'bg-red-500',
    label: 'Low confidence',
  },
};

export default function ConfidencePill({ confidence }: { confidence: ChatbotConfidence }) {
  const s = STYLES[confidence];
  return (
    <span
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full border text-xs font-medium ${s.bg} ${s.text} ${s.border}`}
      title={confidence === 'low' ? 'Low confidence — see evidence' : s.label}
    >
      <span className={`w-1.5 h-1.5 rounded-full ${s.dot}`} />
      {s.label}
    </span>
  );
}
